<template>
  <component
    :is="tag"
    :type="isButton ? 'button' : undefined"
    :to="to"
    :exact="exact"
    :replace="replace"
    :append="append"
    :target="target"
    :disabled="isButton ? disabled : undefined"
    :href="tag === 'a' ? href : undefined"
    :class="classes"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="icon"></i>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    tag: { type: String, default: 'button' }, // 'button' | 'router-link' | 'a'
    variant: { type: String, default: 'primary' }, // primary | outline | ghost | success | danger
    size: { type: String, default: 'md' },     // 'sm' | 'md' | 'lg'
    icon: { type: String, default: '' },
    // Для tag="router-link"
    to: { type: [String, Object], default: '' },
    exact: { type: Boolean, default: false },
    replace: { type: Boolean, default: false },
    append: { type: Boolean, default: false },
    target: { type: String, default: '' },
    // Для tag="button" / "a"
    disabled: { type: Boolean, default: false },
    href: { type: String, default: '' }
  },
  computed: {
    isButton() {
      return this.tag === 'button'
    },
    classes() {
      return [
        'abtn',
        `abtn--${this.variant}`,
        `abtn--${this.size}`
      ]
    }
  }
}
</script>

<style scoped>
.abtn {
  border: var(--border-width-default) var(--border-style-base) transparent;
  border-radius: var(--radius-md);
  font-family: inherit;
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  text-decoration: none;
  transition: background var(--duration-fast) var(--ease-base),
              border-color var(--duration-fast) var(--ease-base),
              box-shadow var(--duration-normal) var(--ease-out),
              transform var(--duration-normal) var(--ease-out);
  user-select: none;
}

.abtn:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.abtn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.abtn i { font-size: 0.85em; }

/* Sizes */
.abtn--sm { padding: var(--space-3) var(--space-8); font-size: var(--text-sm); border-radius: var(--radius-sm); }
.abtn--md { padding: var(--space-4) var(--space-10); font-size: var(--text-base); }
.abtn--lg { padding: var(--space-6) var(--space-16); font-size: var(--text-base); }

/* Variants. Заливные кнопки на наведение чуть приподнимаются */
.abtn--primary        { background: var(--primary); color: var(--text-on-dark); box-shadow: var(--shadow-xs); }
.abtn--primary:hover   { background: var(--primary-hover); box-shadow: var(--shadow-md); transform: translateY(-1px); }

.abtn--outline { background: transparent; color: var(--primary); border-color: var(--primary); }
.abtn--outline:hover { background: var(--primary-soft); }

.abtn--success        { background: var(--color-success-600); color: var(--text-on-dark); box-shadow: var(--shadow-xs); }
.abtn--success:hover   { background: var(--color-success-700); box-shadow: var(--shadow-md); transform: translateY(-1px); }

.abtn--danger        { background: var(--color-danger-600); color: var(--text-on-dark); box-shadow: var(--shadow-xs); }
.abtn--danger:hover   { background: var(--color-danger-700); box-shadow: var(--shadow-md); transform: translateY(-1px); }

.abtn--ghost { background: var(--bg-subtle); color: var(--text-primary); border-color: var(--border-default); }
.abtn--ghost:hover { background: var(--color-neutral-200); }

.abtn:active { transform: scale(0.97); box-shadow: none; }
</style>
